import LoadMapScriptService from './LoadMapScriptService';

export default class MapsApiBaseService {
  googleMaps = null;

  async init() {
    await LoadMapScriptService.load();
    this.googleMaps = google.maps;
  }
}
